// extracted by mini-css-extract-plugin
module.exports = {"back":"index_back__36s6Z","back__icon":"index_back__icon__2bCaC"};